import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { FeatureFlagGuard } from './core/guards/feature-flag.guard';
import { DefaultRouteGuard } from './core/guards/default-route.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, DefaultRouteGuard],
    children: [],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./domain/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./domain/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'propostas',
        loadChildren: () =>
          import('./domain/proposta/proposta.module').then(
            m => m.PropostaModule,
          ),
      },
      {
        path: 'leads',
        loadChildren: () =>
          import('./domain/lead/lead.module').then(m => m.LeadModule),
        canActivate: [FeatureFlagGuard],
        data: {
          featureFlag: 'leads',
        },
      },
      {
        path: 'empresas',
        loadChildren: () =>
          import('./domain/empresa/empresa.module').then(m => m.EmpresaModule),
        canActivate: [FeatureFlagGuard],
        data: {
          featureFlag: 'empresas',
        },
      },
      {
        path: 'contratos',
        loadChildren: () =>
          import('./domain/contrato/contrato.module').then(
            m => m.ContratoModule,
          ),
        canActivate: [FeatureFlagGuard],
        data: {
          featureFlag: 'tratativas_envio_analise',
        },
      },
      {
        path: 'beneficiarios',
        loadChildren: () =>
          import('./domain/beneficiarios/beneficiarios.module').then(
            m => m.BeneficiariosModule,
          ),
        canActivate: [FeatureFlagGuard],
        data: {
          featureFlag: 'negociacao_multiproduto',
        },
      },
      {
        path: 'indicadores',
        loadChildren: () =>
          import('./domain/indicadores/indicadores.module').then(
            m => m.IndicadoresModule,
          ),
        canActivate: [FeatureFlagGuard],
        data: {
          featureFlag: 'indicadores_dashboard',
        },
      },
      {
        path: 'sandbox',
        loadChildren: () =>
          import('./domain/sandbox/sandbox.module').then(m => m.SandboxModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
